import { render, staticRenderFns } from "./CheckoutConfirmWrapper.vue?vue&type=template&id=46f95134"
import script from "./CheckoutConfirmWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutConfirmWrapper.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports